export enum ExternalAPIAuthorizationEnum {
  None = 0,

  BOTH_GET = 1056,
  BOTH_PUT = 2112,
  BOTH_POST = 4224,
  BOTH_DELETE = 8448,
  BOTH_COMMANDS = 16912,

  Dashboard_GET = 32,
  Dashboard_POST = 64,
  Dashboard_PUT = 128,
  Dashboard_DELETE = 256,
  Dashboard_COMMANDS = 512,

  App_GET = 1024,
  App_POST = 2048,
  App_PUT = 4096,
  App_DELETE = 8192,
  APP_COMMANDS = 16384
}

export const ExternalAPIAuthorization = [
  {
    value: 'BOTH_GET',
    text: 'GET (all)',
    enum: ExternalAPIAuthorizationEnum.BOTH_GET
  },
  {
    value: 'BOTH_PUT',
    text: 'PUT (all)',
    enum: ExternalAPIAuthorizationEnum.BOTH_PUT
  },
  {
    value: 'BOTH_POST',
    text: 'POST (all)',
    enum: ExternalAPIAuthorizationEnum.BOTH_POST
  },
  {
    value: 'BOTH_DELETE',
    text: 'DELETE (all)',
    enum: ExternalAPIAuthorizationEnum.BOTH_DELETE
  },
  {
    value: 'BOTH_COMMANDS',
    text: 'COMMANDS (all)',
    enum: ExternalAPIAuthorizationEnum.BOTH_COMMANDS
  }
  // {
  //   value: 'Dashboard_GET',
  //   text: 'GET (dashboard)',
  //   enum: ExternalAPIAuthorizationEnum.Dashboard_GET
  // },
  // {
  //   value: 'Dashboard_POST',
  //   text: 'POST (dashboard)',
  //   enum: ExternalAPIAuthorizationEnum.Dashboard_POST
  // },
  // {
  //   value: 'Dashboard_PUT',
  //   text: 'PUT (dashboard)',
  //   enum: ExternalAPIAuthorizationEnum.Dashboard_PUT
  // },
  // {
  //   value: 'Dashboard_DELETE',
  //   text: 'DELETE (dashboard)',
  //   enum: ExternalAPIAuthorizationEnum.Dashboard_DELETE
  // },
  // {
  //   value: 'Dashboard_COMMANDS',
  //   text: 'COMMANDS (dashboard)',
  //   enum: ExternalAPIAuthorizationEnum.Dashboard_COMMANDS
  // },
  // {
  //   value: 'App_GET',
  //   text: 'GET (app)',
  //   enum: ExternalAPIAuthorizationEnum.App_GET
  // },
  // {
  //   value: 'App_POST',
  //   text: 'POST (app)',
  //   enum: ExternalAPIAuthorizationEnum.App_POST
  // },
  // {
  //   value: 'App_PUT',
  //   text: 'PUT (app)',
  //   enum: ExternalAPIAuthorizationEnum.App_PUT
  // },
  // {
  //   value: 'App_DELETE',
  //   text: 'DELETE (app)',
  //   enum: ExternalAPIAuthorizationEnum.App_DELETE
  // },
  // {
  //   value: 'APP_COMMANDS',
  //   text: 'COMMANDS (app)',
  //   enum: ExternalAPIAuthorizationEnum.APP_COMMANDS
  // }
];
